<div class="widget co-list-grid">
    <h3 class="title-bar h5">Chief's Order Report</h3>
    <span class="searchTitle text-left">Search by Date Range:</span>
    <div class="grid-x grid-margin-x  margin-top">
        <div class="cell medium-3">
            <span class="datePickerLabel">Issued Date From:</span>
        </div>
        <div class="cell medium-3">
            <span class="datePickerLabel">Issued Date To:</span>
        </div>
        <div class="cell medium-6">
        </div>
        <div class="cell medium-3 datePickerContainer">
			<common-date-picker [id]="'fromDateModel'" [initialDate]="fromDate" [placeholder]="placeholder" (dateChanged)="fromDateChange($event)"></common-date-picker>
        </div>
		<div class="cell medium-3 datePickerContainer">
			<common-date-picker [id]="'toDateModel'" [initialDate]="toDate" [placeholder]="placeholder" (dateChanged)="toDateChange($event)"></common-date-picker>
		</div>
        <div class="cell medium-6">
            <button class="button searchButton margin-left" (click)="search()">Search</button>
            <button class="button resetButton margin-left" (click)="reset()">Reset</button>
        </div>
    </div>
        <tabs (tabClicked)="onTabClicked($event)">
            <tab title="All Chief's Orders">
                <div class="cell text-left">
                    <label class="vertical-align-middle inline minor-margin-right" for="displayPending">Display Pending Chief's orders:</label>
                    <input class="no-margin-bottom vertical-align-middle" type="checkbox" id="displayPending" [checked]="mainDisplayPending" (change)="toggleMainTabPendingItemDisplay()" />
                </div>
                <div class="cell text-right">
                    <button class="button no-margin-bottom" (click)="downloadReport()">Download Chief's Order List</button>
                </div>
                <ag-grid-angular class="data-grid  full-page" [rowData]="data"  (paginationChanged)="autoSizeGeneralGrid($event)" [gridOptions]="gridOptions" aria-label="All Chief's Orders">
                </ag-grid-angular>
            </tab>
            <tab title="My Chief's Orders">
                <ag-grid-angular class="data-grid  full-page" [rowData]="filteredData"  (paginationChanged)="autoSizeMyOrdersGrid($event)" [gridOptions]="filteredGridOptions" aria-label="My Chief's Orders">
                </ag-grid-angular>
            </tab>
        </tabs>
    </div>